import {Collapse as MuiCollapse, CollapseProps as MuiCollapseProps} from "@mui/material";
import {easeOutSmooth} from "./keyframes";

type CollapseProps = Omit<MuiCollapseProps, "timeout" | "easing">;

export const Collapse = (props: CollapseProps) => <MuiCollapse timeout={500} easing={easeOutSmooth} {...props} />;
